export default {"src":"/_next/static/media/mysofie-logo.e936f1ab.svg","height":70,"width":114,"blurWidth":0,"blurHeight":0};